import React, { useEffect } from 'react';
import './TermsOfUse.css';
import { Link,} from 'react-router-dom';

const TermsOfUse = () => {
  useEffect(() => {
    // Scroll to top when component mounts
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  return (
    <div className="terms-container">
      <h1>Terms of Use – SMS Consent and Communication</h1>

      <h2>1. SMS Consent Communication</h2>
      <p>
        The information such as <strong>Phone Numbers</strong> obtained as part of the SMS consent process will not be shared with third parties for marketing purposes.
      </p>

      <h2>2. Types of SMS Communications</h2>
      <p>
        If you have consented to receive text messages from <strong>Mindspace Psychiatric Services PLLC</strong>, you may receive messages related to the following:
      </p>
      <ul>
        <li>Appointment reminders</li>
        <li>Billing inquiries</li>
        <li>Promotions or offers</li>
      </ul>

      <h2>3. Message Frequency</h2>
      <p>
        Message frequency may vary depending on the type of communication.
      </p>

      <h2>4. Potential Fees for SMS Messaging</h2>
      <p>
        Please note that standard message and data rates may apply, depending on your carrier’s pricing plan. These fees may vary if the message is sent domestically or internationally.
      </p>

      <h2>5. Opt-In Method</h2>
      <p>
        You may opt-in to receive SMS messages from <strong>Mindspace Psychiatric Services PLLC</strong> in the following ways:
      </p>
      <ul>
        <li>By submitting an online form</li>
      </ul>

      <h2>6. Opt-Out Method</h2>
      <p>
        You can opt out of receiving SMS messages at any time. To do so, simply reply "STOP" to any SMS message you receive. Alternatively, you can contact us directly to request removal from our messaging list.
      </p>

      <h2>7. Help</h2>
      <p>
        If you are experiencing any issues, you can reply with the keyword "HELP". Or, you can get help directly from us at <Link to='/'>Mindspace</Link>.
      </p>

      <h3>Additional Options:</h3>
      <p>
        If you do not wish to receive SMS messages, you can choose not to check the SMS consent box on our forms.
      </p>

      <h2>8. Standard Messaging Disclosures</h2>
      <ul>
        <li>Message and data rates may apply.</li>
        <li>You can opt out at any time by texting "STOP."</li>
        <li>
          For assistance, text "HELP" or visit our{' '}
          <Link to="/privacy-policy">Privacy Policy</Link> and{' '}
          <Link to="/terms-of-use">Terms and Conditions</Link> pages.
        </li>
        <li>Message frequency may vary.</li>
      </ul>
    </div>
  );
};

export default TermsOfUse;
